import { isPlatform, isWeb } from '@volt-libs/foundation'
const production = {
    env: 'production',
    supportedLanguages: ['en', 'zh'],
    authenticationType: `${isWeb ? 'oauth' : 'iptv'}`,
    authenticationTypeTv: ['iptv'],
    isNewRelicDisabled: !isWeb,
    urls: {
        apiUrl: 'https://api.starhub.otvse.com',
        authUrl: 'https://auth.starhub.com',
        externalDrmUrl: 'https://drm.mewatch.sg',
        externalDrmTrackerUrl: 'https://uid.mediacorp.sg',
        optaUrl: 'https://waf-starhub-metadata-api-p001.sh-ifs.com/f309sdicsc/',
        configUrl: '',
        gatewayApiUrl: 'https://ott.starhub.com',
        gatewayTokenApiUrl: 'https://6vxer7i65rwzth75lc3yg5ve5m0objzq.lambda-url.ap-southeast-1.on.aws/',
        emi: {
            baseUrl: 'https://waf-starhub-emi-static-api-p001.sh-ifs.com',
            homePath: `3.0/{population}/${isWeb ? 1 : 3}`,
            defaultPopulation: 'prod',
        },
        proxyUrl: 'https://waf-starhub-metadata-api-p001.sh-ifs.com/v3.1',
        imagesUrl: '',
        introspectUrl: '',
        licenceUrl: '',
        pinValidationUrl: '',
        recoUrl: '',
        registerDeviceUrl: '',
        searchUrl: '',
        reportVulnerabilityUrl: 'https://vdp.starhub.com',
        helpAndFaqUrl: 'https://www.starhub.com/tvplus-faq',
        termsAndConditions: 'https://corporate.starhub.com/about-us/legal-notices-and-terms.html',
        mobileAppTermsAndConditions: 'https://corporate.starhub.com/content/dam/starhub/legal-notices-and-terms/consumer/starhub-tvplus.pdf',
        mobilePrivacyPolicy: "https://corporate.starhub.com/content/dam/starhub/legal-notices-and-terms/consumer/personal-data-protection-policy.pdf",
        manageSubscriptionURL : "https://starhub.com/personal/apps/starhub-app.html",
        store: {
            applePhone: 'https://apps.apple.com/sg/app/starhub-tv/id586220439',
            appleTablet: 'http://starhub.com/tvplus-pro-help',
            googlePhone: 'https://play.google.com/store/apps/details?id=com.starhub.itv&hl=en_GB&gl=US',
            googleTablet: 'http://starhub.com/tvplus-pro-help',
            chromeBrowser: 'https://www.google.com/chrome/',
            androidAppId: 'com.starhub.itv',
        },
        socialMedia: {
            facebook: "https://www.facebook.com/",
            messanger: "https://www.messenger.com/",
            instagram: "https://instagram.com/",
            youtube: "https://www.youtube.com/",
            twitter: "https://twitter.com/",
        }
    },
    clientId: isPlatform('laptop') ? 'iFeelSmart5nDbXS5ycxAmuCwFYue6ulQyMcQy10xcS' : 'STBlWORmpY2O0OpgbR5zmUbKq7r3YjvxM6dfM35f696',
    clientSecret: isPlatform('laptop') ? 'OrJWnWvyWApWAV2wWuc2j58eWisPfmAaErSrEbydtO0' : '8ooc7voLHiMZq18LKjfblcEmXJBRbe9AcM4WvS4LTHJ',
    allowGuest: isWeb,
    showTrailer: true,
    eplFeatures : {
        matchStatistics: true,
        matchEvents: true,
        multiCamValue: 1, // 0: Not supported, 1: Supported single view, 2: Supported multi view, here 2 views at a time,...
    },
    showRentSubscription: isWeb,
    OAuthParam: {
        grantType: 'authorization_code',
        endpoint: {
            auth: '/oauth/authorize',
            deviceCode: '/device/request',
            token: isWeb ? '/oauth/token' : '/device/token',
            refreshToken: '/oauth/token',
            fullTokenUrl: 'https://6vxer7i65rwzth75lc3yg5ve5m0objzq.lambda-url.ap-southeast-1.on.aws/',
            fullRefreshTokenUrl: 'https://6vxer7i65rwzth75lc3yg5ve5m0objzq.lambda-url.ap-southeast-1.on.aws/',
        },
        debugMode: true,
        forcePollingIntervalSecs: 10,
    },
    opta: {
        outletToken: '11l86zcp8kopy1hmvug79dxcb3',
        posterServerUrl: 'https://poster.starhubgo.com',
        optaReferer: 'https://ifsproxy.sh-ifs.com',
        useLegacyIds: true,
        enabled: true,
        matchEventsEnabled: true,
        matchLineUpEnabled: true,
        liveSimulatorEnabled: false,
        statsPeriodAutoRefresh: 60 * 1000, // 60000 ms | 1 min
    },
    proxyVersion: 3,
    ufinity: {
        jwt: {
            iss: 'iFeelSmart',
            privateKey: 'qa2O9mLSdYGPjtlonvL1WsNM3zynzmrIqHE9rTrvdM4=',
            // This part trigger internal web service for generating the Ufinity JWT Token - Disabled and need to be moved outisde this object for better readability
            isUseJwtService: true,
            jwtServiceSecret: 'aUZlZWxTbWFydF9Qcm9kdWN0aW9u',
            jwtClientId: 'iFeelSmart_Production',
        },
        // Temporary disable due to performance issue with JWT
        disableNotifyUserLogin: true,
        disableOfferDetails: true,
        // Packs allowed to be purchased : LIGER and APPS
        enabledSubscriptionsProductTypesOpenDevice: ['INTERNET', 'PPV'],
        oneTypeChargeProductTypes: ['PPV'],
        // DEBUG MODE. to allow to login from the Username/Password page without a second screen
        debugForceTvServiceAutoSelection: false,
    },
    nagra: {
        tenantId: 'nagra',
        metadataProvider: 'GLOBAL',
        rollingBufferDuration: 24,
        widevineLicenseUrl: 'https://scvm1sc0.anycast.nagra.com',
        SSMLicenseUrl: 'https://scvm1sc0-ssm.anycast.nagra.com/SCVM1SC0/ssm',
        fairplayLicenseUrl: 'https://scvm1sc0.anycast.nagra.com',
        fairplaySSMLicenseUrl: 'https://scvm1sc0-ssm.anycast.nagra.com/SCVM1SC0/ssm/v1',
        fetchOnlySubscribedProducts: false,
        playerTenantId: 'SCVM1SC0',
        useTokenization: true,
    },
    voltPlayer: {
        drmConfig: {},
        mediaEngine: 'nagra',
    },
    mediacorp: {
        network: 'starhub',
        partnerId: 'JIUzI1NiJ9',
        partnerToken: '4448c697-6819-441c-8bf8-32b73f66662b',
        refreshTokenTimeoutMs: 1 * 60 * 60 * 1000, // Internal value for refreshing mediacorp access token
        kidCachingIntervalMs: 1 * 60 * 60 * 1000, // Interval for caching the KID
    },
    gfkAnalytics: {
        enable: !isWeb,
        contentId: 'Linear',
        streamId: 'StarhubTizenTV',
        mediaId: 'StarhubTizenTV',
        sdkJsonUrl: 'https://sg-config.sensic.net/s2s-android.json',
        url: 'https://sg-config.sensic.net/ctv/s2s-web.js',
        media: 's2s-html5-demo',
        type: 'TV',
        device: 'SMART-TV',
        logLevel: 'none',
    },
    broadpeak: {
        enable: true, // enable broadpeak support (need also to be activated in settings.gradle)
        adsEnable: true, // enable ads integration (need also to be activated in settings.gradle)
        analyticsAddress: 'https://sh-bka.starhubgo.com', // broadpeak analytics address
        nanoCDNHost: '', // nanoCDN Host needed to support multicast CDN
        broadpeakDomainNames: 'ucdn.starhubgo.com', // broadpeakDomainNames
    },
    encryption: {
        enabled: true,
        passphrase: 'mY5}vH9%pN0!dW7{xI7$aG8{iK8}aT2/',
    },
    firebaseConfig: {
        enabled: true,
        apiKey: `${isWeb ? 'AIzaSyAS9v7QFMJ7WjVMrE1OWYVeJKBjiZVbjDM' : 'AIzaSyBRHNdU06_a71J6f0WM1hZlcr2AD_Reg9s'}`,
        authDomain: "starhub-ifs-uat.firebaseapp.com",
        projectId: "starhub-ifs-uat",
        storageBucket: `${isWeb ? 'starhub-ifs-uat.appspot.com' : 'starhub-ifs-uat.firebasestorage.app'}`,
        messagingSenderId: "359855094350",
        appId: `${isWeb ? '1:359855094350:web:5dd6ac3a564e9d9ce6a11f' : '1:359855094350:web:aca86ddf73dca762e6a11f'}`,
        measurementId: `${isWeb ? 'G-PK9WDYV3C2' : 'G-YKCCV7MTXT'}`
    },
    conviva: {
        enable: true,
        customerKey: '6f439b4547952ebee4b632106883445af2e7f656',
        gatewayUrl: '',
        logLevel: 0,
        applicationName: 'webStv',
    },
    adobeAnalytics: {
        enabled: true,
        analyticsUserUrl: 'https://dpm.demdex.net/id',
        analyticsApiUrl: 'https://mediacorp.hb-api.omtrdc.net/api/v1',
        trackingServer: 'mediacorp.sc.omtrdc.net',
        reportSuit: 'mediacorp-mcs-prd',
        organisationId: 'B464317853A9C8390A490D4E@AdobeOrg',
        apiVersion: 2,
    },

    heroSliderAutoplay : isWeb ? true : true,
    hybridHeight: isWeb ? '135px': '250px',
    showBingeWatch : true,
}

export default production
